<template>
  <div>
    <tableComponents
      ref="tableComponents"
      :isHaveExport="false"
      :isHavePagination="false"
      :isShow="false"
      @toAdd="showAddDialog"
    >
      <template v-slot:table>
        <el-table v-if="!isMobileViewport" :data="list" style="width: 100%" :border="true">
          <el-table-column prop="name" label="规则名称" min-width="180" align="center">
            <template v-slot="scope">
              <div class="scheduler-name-cell">
                <span>{{ scope.row.name }}</span>
                <el-tag
                  v-if="scope.row.is_system_scheduler"
                  size="mini"
                  type="info"
                  effect="plain"
                >
                  系统生成
                </el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="description" label="规则描述" min-width="220" align="center" />

          <el-table-column prop="is_active" label="是否激活" width="110" align="center">
            <template v-slot="scope">
              <el-switch
                v-model="scope.row.is_active"
                :active-value="1"
                :inactive-value="0"
                @change="changeActiveStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column prop="handler_module" label="处理模块" min-width="180" align="center" />

          <el-table-column
            prop="operation"
            align="center"
            label="操作"
            :width="isMobileViewport ? 76 : 210"
            fixed="right"
          >
            <template v-slot="scope">
              <responsive-actions
                :items="getSchedulerRowActions(scope.row)"
                @select="handleSchedulerRowAction($event, scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <mobile-record-list
          v-else
          :rows="list"
          :title="getMobileSchedulerTitle"
          :subtitle="getMobileSchedulerSubtitle"
          :fields="mobileSchedulerFields"
          :actions="getSchedulerRowActions"
          @action="handleSchedulerRowAction"
        />
      </template>
    </tableComponents>

    <el-dialog
      :title="isEditing ? '编辑规则' : '新增规则'"
      :visible.sync="dialogVisible"
      width="640px"
      @closed="resetDialog"
    >
      <el-form
        ref="form"
        :model="ruleForm"
        label-width="120px"
        size="small"
        :rules="rules"
      >
        <el-form-item label="规则名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            :disabled="isSystemSchedulerEditing"
            placeholder="请输入规则名称"
          />
        </el-form-item>

        <el-form-item label="规则描述" prop="description">
          <el-input
            v-model="ruleForm.description"
            :disabled="isSystemSchedulerEditing"
            type="textarea"
            placeholder="请输入规则描述"
          />
        </el-form-item>

        <el-form-item label="是否激活" prop="is_active">
          <el-switch
            v-model="ruleForm.is_active"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>

        <el-form-item label="处理模块" prop="handler_module">
          <el-select
            v-model="ruleForm.handler_module"
            :disabled="isSystemSchedulerEditing"
            placeholder="请选择处理模块"
            style="width: 100%"
          >
            <el-option
              v-for="item in handlerModuleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <el-form :model="ruleForm.handler_config">
        <el-form-item
          v-for="(item, i) in configsFormList"
          :key="i"
          :prop="item.key"
          :label="item.label"
          label-width="120px"
        >
          <template v-if="item.type === 'input'">
            <el-input
              :type="item.form_type || 'text'"
              v-model="ruleForm.handler_config[item.key]"
              :placeholder="item.placeholder || '请输入内容'"
              :disabled="isSystemSchedulerEditing || item.disabled || false"
            />
          </template>
          <template v-else-if="item.type === 'select'">
            <el-select
              v-model="ruleForm.handler_config[item.key]"
              style="width: 100%"
              clearable
              :placeholder="item.placeholder || '请选择'"
              :multiple="item.multiple || false"
              :filterable="item.filterable || false"
              :allow-create="item['allow-create'] || false"
              :disabled="isSystemSchedulerEditing"
            >
              <el-option
                v-for="option in item.option"
                :key="option.id"
                :label="option[item.labelKey || 'nickname']"
                :value="option.id"
              />
            </el-select>
          </template>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveRule">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { isSystemScheduler } from "@/utils/riskTask";
import responsiveMixin from "@/mixins/responsive";

const defaultRuleForm = () => ({
  id: "",
  name: "",
  description: "",
  is_active: 1,
  handler_module: "",
  handler_config: {},
  is_system_scheduler: false,
});

export default {
  mixins: [responsiveMixin],
  data() {
    return {
      dialogVisible: false,
      isEditing: false,
      ruleForm: defaultRuleForm(),
      rules: {
        name: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        handler_module: [
          { required: true, message: "请选择处理模块", trigger: "change" },
        ],
      },
      list: [],
      configFormOptions: [],
      handlerModuleOptions: [],
    };
  },
  computed: {
    mobileSchedulerFields() {
      return [
        { label: "规则描述", key: "description" },
        {
          label: "激活状态",
          value: (row) => (Number(row.is_active) === 1 ? "已激活" : "未激活"),
          tag: true,
          tagType: (row) => (Number(row.is_active) === 1 ? "success" : "info"),
        },
        { label: "处理模块", key: "handler_module" },
        {
          label: "规则类型",
          value: (row) => (row.is_system_scheduler ? "系统生成" : "自定义"),
          tag: true,
          tagType: (row) => (row.is_system_scheduler ? "info" : "primary"),
        },
        { label: "规则ID", key: "id", summary: false },
      ];
    },
    isSystemSchedulerEditing() {
      return this.isEditing && isSystemScheduler(this.ruleForm);
    },
    configsFormList() {
      const handlerModule = this.configFormOptions.find(
        (item) => item.handlerModuleStr === this.ruleForm.handler_module
      );
      return handlerModule?.fields || [];
    },
  },
  methods: {
    getMobileSchedulerTitle(row) {
      return row.name || `调度规则 #${row.id}`;
    },
    getMobileSchedulerSubtitle(row) {
      return row.is_system_scheduler ? "系统生成" : `规则ID ${row.id || "--"}`;
    },
    getSchedulerRowActions(row) {
      return [
        { key: "edit", label: "编辑", type: "primary" },
        {
          key: "delete",
          label: "删除",
          type: "danger",
          disabled: Boolean(row.is_system_scheduler),
        },
      ];
    },
    handleSchedulerRowAction(key, row) {
      if (key === "edit") this.editRule(row);
      if (key === "delete") this.deleteRule(row.id);
    },
    async getRuleList() {
      try {
        const data = await this.$api.getSchedulers.getSchedulersList();
        this.list = Array.isArray(data.data) ? data.data : [];
        this.handlerModuleOptions = data.handlerModuleOptions || [];
        this.configFormOptions = data.configFormOptions || [];
      } catch (error) {
        console.error("获取规则列表失败:", error);
      }
    },
    showAddDialog() {
      this.isEditing = false;
      this.ruleForm = defaultRuleForm();
      this.dialogVisible = true;
    },
    resetDialog() {
      this.ruleForm = defaultRuleForm();
      this.isEditing = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    async saveRule() {
      try {
        const params = {
          ...this.ruleForm,
          handler_config: JSON.stringify(this.ruleForm.handler_config || {}),
        };
        this.$refs.form.validate(async (valid) => {
          if (!valid) {
            return;
          }
          if (this.isEditing) {
            await this.$api.getSchedulers.saveSchedulers(params);
            this.$message.success("规则更新成功");
          } else {
            await this.$api.getSchedulers.addSchedulers(params);
            this.$message.success("规则新增成功");
          }
          this.dialogVisible = false;
          this.getRuleList();
        });
      } catch (error) {
        console.error("保存规则失败:", error);
        this.$message.error("保存规则失败");
      }
    },
    editRule(rule) {
      this.isEditing = true;
      const nextRule = {
        ...defaultRuleForm(),
        ...rule,
      };
      try {
        nextRule.handler_config =
          typeof rule.handler_config === "string"
            ? JSON.parse(rule.handler_config)
            : rule.handler_config || {};
      } catch (error) {
        nextRule.handler_config = {};
      }
      this.ruleForm = nextRule;
      this.dialogVisible = true;
    },
    deleteRule(id) {
      this.$confirm("确定要删除这条规则吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.getSchedulers.delSchedulers({ id });
          this.$message.success("删除成功");
          this.getRuleList();
        })
        .catch(() => {});
    },
    async changeActiveStatus(rule) {
      try {
        await this.$api.getSchedulers.saveSchedulers({
          is_active: rule.is_active,
          id: rule.id,
        });
        this.$message.success("状态更新成功");
      } catch (error) {
        rule.is_active = rule.is_active === 1 ? 0 : 1;
        console.error("状态更新失败:", error);
        this.$message.error("状态更新失败");
      }
    },
  },
  created() {
    this.getRuleList();
  },
};
</script>

<style lang="less" scoped>
.el-table {
  margin-top: 20px;
}

.el-dialog {
  .el-form-item {
    margin-bottom: 20px;
  }
}

.el-select,
.el-input {
  width: 100%;
}

.scheduler-name-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.scheduler-action-wrapper {
  display: inline-block;
}
</style>
